import { useEffect, useState } from 'react';
import { api, setUnauthorizedHandler } from './lib/api';
import { useApi } from './lib/useApi';
import Login from './screens/Login';
import ClientModuleShell from './clientModule/ClientModuleShell';

export default function App() {
  const [user, setUser] = useState(undefined); // undefined = checking

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null));
    api.get('/api/auth/me').then(setUser).catch(() => setUser(null));

    try {
      const theme = localStorage.getItem('theme') || 'light';
      if (theme === 'dark') {
        document.body.classList.add('dark-theme');
      } else {
        document.body.classList.remove('dark-theme');
      }
    } catch (e) {}
  }, []);

  if (user === undefined) return <div className="app"><div className="center" style={{ height: '100vh' }}>Loading…</div></div>;
  if (!user) return <Login onLogin={setUser} />;
  
  return <Shell user={user} onUpdateUser={setUser} onLogout={() => setUser(null)} />;
}

function Shell({ user, onUpdateUser, onLogout }) {
  const { data: config, loading, error, reload } = useApi('/api/setup');

  if (loading && !config) return <div className="app"><div className="center" style={{ height: '100vh' }}>Loading…</div></div>;
  if (error || !config) {
    return (
      <div className="app"><div className="screen">
        <div className="err" style={{ marginTop: 40 }}>Couldn’t load your sheet: {error || 'unknown error'}</div>
        <button className="btn" onClick={reload}>Retry</button>
      </div></div>
    );
  }

  return (
    <div className="app app-full-width">
      <ClientModuleShell user={user} config={config} reloadConfig={reload} onUpdateUser={onUpdateUser} onLogout={onLogout} />
    </div>
  );
}
